'use client';

import { createContext } from 'react';

import type { AdornedInputContextInterface } from '../types/adorned-input-root.types';

export const AdornedInputContext = createContext<AdornedInputContextInterface>({});

AdornedInputContext.displayName = 'AdornedInput.Context';
